import classNames from 'classnames'

export const sleep = (ms: number) => new Promise(resolve => setTimeout(resolve, ms))

/** Shorthand for classNames() function for constructing CSS class names */
export const cn = classNames
